import { render } from "./Chapter12.vue?vue&type=template&id=5d957a15"
import script from "./Chapter12.vue?vue&type=script&lang=js"
export * from "./Chapter12.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__